export
const name: string = "SsaoGeometryCutOff";

export
const preproc: string = ``;

export
const declaration: string = `
    uniform sampler2D u_heightTexture; // Special texture for grass cutoff under model
`;

export
const varyings: string = `
    varying vec3    v_position;
    varying float   v_visibility;
    varying vec4    v_relativePosition;
`;

export
const implementation: string = `
    void main(void)
        {
        if (v_visibility < 0.5) {
            discard;
        }

	#ifdef CLIPPING_PLANE
        if (resolveClippingPlane()) {
            #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)

            discard;

            #endif
        }
    #endif

        // Resolve height
        vec2 relative = v_relativePosition.xy / v_relativePosition.w * 0.5 + 0.5;
        vec4 heightData = texture2D(u_heightTexture, relative);

        // Test if any data was written
        if (heightData.x < 1.0 && heightData.y < 1.0 && heightData.z < 1.0 && heightData.w < 1.0) {
            float height = - vec4ToFloat(heightData);
            if (v_relativePosition.z / v_relativePosition.w >= height) {
                discard;
            }
        }

        gl_FragColor = vec4(v_position, 1.0);

    #ifdef LOGDEPTH
        resolveLogarithmicDepth();
    #endif
    }
`;
